module.exports = __webpack_public_path__ + "img/mask.6e02b877.svg";